export enum ApprovalTypeEnum {
	PORequisition = 1,
	Invoice = 3
}
